import { Translations } from "../utils/Translator"
import C from "./Constants"

export default class Database
{
    constructor(translator)
    {
        this.translator = translator
        this.meshUrl = `https://3dwine.bbsway.it/api/index.php/meshes/${this.translator.lang}`
        this.grapeUrl = `https://3dwine.bbsway.it/api/index.php/grapes/${this.translator.lang}`
        this.wineUrl = `https://3dwine.bbsway.it/api/index.php/wines/${this.translator.lang}`
    }

    static async initDatabase(translator)
    {
        const db = new Database(translator)

        db.meshes = JSON.parse(await db.httpRequest(db.meshUrl))
        db.grapes = JSON.parse(await db.httpRequest(db.grapeUrl))
        db.wines = JSON.parse(await db.httpRequest(db.wineUrl))
        db.distinctGrapes = db._getDistinctGrapes()

        db._normalizeArrays()

        return db
    }

    /**
     * Connection
     */
    async httpRequest(url)
    {
        const response = await fetch(url)
        if(response.ok)
        {
            return await response.text()
        }
    }

    /**
     * Utils
     */
    _normalizeArrays()
    {
        this.meshes.sort((a, b) => a.order - b.order)
        this.grapes.sort((a, b) => a.order - b.order)
        this.wines.sort((a, b) => a.order - b.order)
        this.distinctGrapes.sort((a, b) => a.order - b.order)

        this.meshes.forEach(m => m.permalink = this.translator.localizePermalink(m.permalink))
        this.grapes.forEach(m => m.permalink = this.translator.localizePermalink(m.permalink))
        this.wines.forEach(m => m.permalink = this.translator.localizePermalink(m.permalink))
        this.distinctGrapes.forEach(m => m.permalink = this.translator.localizePermalink(m.permalink))

        const forest = this.meshes.find(x => x.meshElement === 'forest')
        const azienda = this.meshes.find(x => x.meshElement === 'building_1')
        const villa = this.meshes.find(x => x.meshElement === 'building_villa')

        const projectsUrl = Translations.project[`${this.translator.lang}Url`]
        forest.permalink = projectsUrl
        azienda.permalink = projectsUrl
        villa.permalink = projectsUrl
    }

    _getDistinctGrapes()
    {
        const result = []
        for(let g of this.grapes)
        {
            const polishedName = g.name.replace(/ *\([^)]*\) */g, "")
            const existingElement = result.find(x => x.name === polishedName)
            if(existingElement === undefined)
            {
                result.push(
                    {
                        id: [g.id],
                        name: polishedName,
                        description: g.description,
                        meshElement: [g.meshElement],
                        permalink: g.permalink,
                        order: g.order
                    }
                )
            }
            else
            {
                if(polishedName === g.name)
                {
                    existingElement.id.unshift(g.id)
                    existingElement.meshElement.unshift(g.meshElement)
                    existingElement.description = g.description,
                    existingElement.permalink = g.permalink
                    existingElement.order = g.order
                }
                else
                {
                    existingElement.id.push(g.id)
                    existingElement.meshElement.push(g.meshElement)
                }
            }
        }
        return result
    }

    /**
     * Getters
     */
    getItemFromMesh(meshName)
    {
        const item = this.meshes.find(x => x.meshElement === meshName)
        if(item === undefined) return undefined

        const grape = this.grapes.find(x => x.id === item.id)
        if(grape === undefined) return item

        if(C.VARS.mode === 'w')
        {
            let wine = this.wines.find(x => x.grapes.some(y => y.id === grape.id))
            return wine
        }
        else
        {
            return grape
        }
    }

    getWineFromId(itemId)
    {
        let wine = this.wines.find(x => x.id === itemId)
        if(wine !== undefined) return wine.name
    }

    getItemFromId(itemId)
    {
        let result = this.meshes.find(x => x.id === itemId)
        if(result === undefined) result = this.wines.find(x => x.id === itemId)
        return result
    }

    getMeshesFromId(itemId)
    {
        const grapes = this.distinctGrapes.find(x => x.id.includes(itemId))
        if(grapes !== undefined)
        {
            return grapes.meshElement
        }

        const mesh = this.meshes.find(x => x.id === itemId)
        if(mesh !== undefined)
        {
            return [mesh.meshElement]
        }

        const wine = this.wines.find(x => x.id === itemId)
        if(wine !== undefined) return wine.grapes.map(x => x.meshElement)
    }

    getDefaultWineId()
    {
        let defaultWine = this.wines.find(x => x.name === 'Gemma')
        if(defaultWine === undefined) defaultWine = this.wines[0]
        return defaultWine.id
    }

    /**
     * Controllers
     */
    isWine(meshId)
    {
        const wine = this.wines.find(x => x.id === meshId)
        return wine !== undefined
    }

    isWineEnabled(meshName)
    {
        const grape = this.grapes.find(x => x.meshElement === meshName)
        if(grape === undefined) return false

        const wines = this.wines.find(x => x.grapes.some(y => y !== null && y.id === grape.id))
        return wines !== undefined
    }

    isGrapeEnabled(meshName)
    {
        const grape = this.grapes.find(x => x.meshElement === meshName)
        return grape !== undefined
    }

    /**
     * Details
     */
    getDisplayItemFromId(itemId)
    {
        const grape = this.distinctGrapes.find(x => x.id.includes(itemId))
        if(grape !== undefined) return grape

        const mesh = this.meshes.find(x => x.id === itemId)
        if(mesh !== undefined) return mesh

        const wine = this.wines.find(x => x.id === itemId)
        return wine
    }

    getDisplayName(itemId)
    {
        const item = this.getDisplayItemFromId(itemId)
        return item !== undefined ? item.name : ''
    }

    getPermalink(itemId)
    {
        const item = this.getDisplayItemFromId(itemId)
        return item !== undefined ? item.permalink : ''
    }
}